/**
 * Ticket / join codes.
 *
 * The alphabet has no O against 0 and no I against 1, because these get read
 * aloud across a noisy room and typed into a phone by someone holding a pint.
 */
export const CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const CODE_LENGTH = 6;
/** 32 symbols = exactly 5 bits, so masking a random byte is unbiased. */
const MASK = 0b11111;
export function generateCode(randomBytes, length = CODE_LENGTH) {
    const bytes = randomBytes(length);
    let out = '';
    for (let i = 0; i < length; i++) {
        out += CODE_ALPHABET[bytes[i] & MASK];
    }
    return out;
}
/**
 * Fold what a human typed onto the canonical form: strip spaces and dashes and
 * uppercase. Nothing more.
 *
 * Deliberately no glyph substitution: the alphabet excludes O, I, 0 and 1
 * *together*, so a real code never contains any of them and there is no valid
 * character to fold a typed "0" onto. Guessing here would turn a typo into a
 * lookup for somebody else's ticket. Let isValidCodeShape reject it and let the
 * player read the code again.
 */
export function normalizeCode(input) {
    return input.trim().toUpperCase().replace(/[\s-]/g, '');
}
export function isValidCodeShape(code) {
    if (code.length !== CODE_LENGTH)
        return false;
    for (const ch of code)
        if (!CODE_ALPHABET.includes(ch))
            return false;
    return true;
}
//# sourceMappingURL=codes.js.map